import { isBrowser } from '~/bridge/util/isBrowser'

export const safeWindow: Window | undefined = (() =>
  isBrowser() ? window : undefined)()
